<style >
@import "../../static/css/news.css";
</style>
<template>
  <div class="main" id="newsMain">
    <!------------------------------------------ 文章  ---------------------------------------------->
    <!-- 文章内容 -->
    <!--
    <back-to-top
      transitionName="fade"
      :customStyle="myBackToTopStyle"
      :visibilityHeight="300"
      :backPosition="50"
    ></back-to-top>
    <img
      v-show="backtotopVisible"
      class="btn-backtotop"
      src="static/img/backtotop.png"
      @click="handleBacktotop"
    >
    -->
    <van-loading class="conents-loading" color="white" v-if="conentsLoading"/>
    <!-- 普通文章头部 -->
    <div
      v-show="!mapArticleVisible && news.sid!=208 && news.cid!=209"
      class="server-news-title-wrap"
      v-bind:style="{ backgroundImage: 'url(static/img/article/bg.png),url('+news.thumbnail+')'}"
    >
      <!-- templet master-->
      <div class="article-icon-warp">
        <img
          class="btn-navigation"
          src="static/img/comments/icon-navigation.png"
          v-if="(news.latlng && news.latlng != null)"
          @click="handleNavigation"
        >
        <img
          class="btn-vr"
          src="static/img/btn-vr.png"
          v-if="(news.vr && news.vr != null && !MPWEIXIN)"
          @click="handleVr(news.vr)"
        >
        <div class="btn-comments-warp" @click="handleComment">
          <img
            class="btn-comments"
            src="static/img/comments/btn-comments.png"
            v-if=" news.title !='' "
            style
          >
          <span class="comments-total" v-if="commentTotal>0">{{commentTotal}}</span>
        </div>
      </div>
      <!-- templet master end -->
      <h2>{{news.title}}</h2>
      <div class="server-news-info-wrap">
        <span>
          {{news.categoryName}}
          <span class="article-createtime">{{news.addTime}}</span>
        </span>
        <span class="eye-wrap" v-if=" news.title !='' ">
          <img class="eye" src="static/img/article/eye.png">
          {{news.visits}}
        </span>
      </div>
    </div>
    <!-- 普通文章头部 end-->

    <!-- 酒店民宿文章头部 -->
    <div
      v-show="news.sid==208"
      class="server-news-title-wrap"
      v-bind:style="{ backgroundImage: 'url(static/img/article/bg.png),url('+news.thumbnail+')'}"
      style="     max-height: 135px;padding: 34% 4.67% 4.67% 4.67%; height: 29.66%;"
    >
      <!-- templet-->
      <div class="article-icon-warp">
        <img
          class="btn-navigation"
          src="static/img/comments/icon-navigation.png"
          v-if="(news.latlng && news.latlng != null)"
          @click="handleNavigation"
        >
        <img
          class="btn-vr"
          src="static/img/btn-vr.png"
          v-if="(news.vr && news.vr != null && !MPWEIXIN)"
          @click="handleVr(news.vr)"
        >
        <div class="btn-comments-warp" @click="handleComment">
          <img
            class="btn-comments"
            src="static/img/comments/btn-comments.png"
            v-if=" news.title !='' "
            style
          >
          <span class="comments-total" v-if="commentTotal>0">{{commentTotal}}</span>
        </div>
      </div>
      <!-- templet end -->

      <h2>{{news.title}}</h2>
      <div class="info-wrap" style="color: #FFF;">
        <div class="info-tel" style="line-height: 25px;">
          <span>
            星级：
            <img
              class="eye"
              src="static/img/service/hotel/star-w.png"
              v-for="(starItem,starIndex) in news.star"
              style="width: 4% !important;"
            >
          </span>
        </div>
        <span>地址：{{news.address}}</span>
        <div class="info-tel" style="line-height: 25px;width: 91%;">
          <span>联系电话：{{news.tel }}</span>
          <span class="eye-wrap" style="float: right;">
            <img class="eye" src="static/img/article/eye.png">
            {{news.visits}}
          </span>
        </div>
      </div>
    </div>
    <!-- 酒店民宿文章头部 end -->

    <!-- 地图文章头部 -->
    <div
      v-show="news.cid==209"
      class="server-news-title-wrap server-news-map-title-wrap"
      v-bind:style="{ backgroundImage: 'url(static/img/article/bg.png),url('+news.thumbnail+')'}"
    >
      <!-- templet-->
      <div class="article-icon-warp">
        <img
          class="btn-navigation"
          src="static/img/comments/icon-navigation.png"
          v-if="(news.latlng && news.latlng != null)"
          @click="handleNavigation"
        >
        <img
          class="btn-vr"
          src="static/img/btn-vr.png"
          v-if="(news.vr && news.vr != null && !MPWEIXIN)"
          @click="handleVr(news.vr)"
        >
        <div class="btn-comments-warp" @click="handleComment">
          <img class="btn-comments" src="static/img/comments/btn-comments.png" style>
          <span class="comments-total" v-if="commentTotal>0">{{commentTotal}}</span>
        </div>
      </div>
      <!-- templet end -->
      <h2>{{news.title}}</h2>
      <div class="info-wrap">
        <span>地址：{{news.address}}</span>
        <div class="info-tel" style="line-height: 25px;width: 91%;">
          <span>电话：{{news.tel }}</span>
          <span class="eye-wrap">
            <img class="eye" src="static/img/article/eye.png">
            {{news.visits}}
          </span>
        </div>
      </div>
    </div>
    <!-- 地图文章头部 end -->

    <div class="server-news-contents" v-html="news.contents"></div>
    <div class="copyright-wrap">
      <p>{{news.copyright}}</p>
      <div class="copyright-ad">
        <img :src="news.ad">
      </div>
    </div>

    <!-- 文章内容 end-->
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import request from "@/utils/request";

import { Loading } from "vant";
import BackToTop from "@/components/BackToTop.vue";

export default {
  name: "News",
  components: {
    "back-to-top": BackToTop,
    "van-loading": Loading
  },
  data() {
    return {
      conentsLoading: true,
      backtotopVisible: false,
      myBackToTopStyle: {
        right: "4%",
        bottom: "1.58rem",
        width: "40px",
        height: "40px",
        "border-radius": "4px",
        "line-height": "45px", // 请保持与高度一致以垂直居中 Please keep consistent with height to center vertically
        background: "#e7eaf1" // 按钮的背景颜色 The background color of the button
      },
      sid: 0,
      newsId: 0,
      isHotelArticle: false,
      mapArticleVisible: false,
      articleVisible: false,
      displayArticleTimer: "",
      articleY: "translateY(-100%)",
      articleOpacity: 0,
      articleSrc: "",
      commentTotal: 0,
      backtotopVisible: false,
      news: {
        id: 0,
        sid: 0,
        cid: 0,
        title: "",
        contents: "",
        categoryName: "",
        thumbnail: "",
        shareimg:"",
        addTime: "",
        visits: 0,
        address: "",
        tel: "",
        copyright: "",
        ad: "",
        latlng: ""
      }
    }
  },
  destroyed() {},
  mounted() {
    console.log("mounted()");
    this.style = this.$route.query.style;
    this.newsId = this.$route.query.id;
    if (this.style) {
      this.removeLoader();
      let cid = this.$route.query.style;
      let idArray = this.$route.query.idArray;
      console.log("this.$refs.refNewsList:", this.$refs.refNewsList);
      this.$refs.refNewsList.getInid(cid, 8, idArray);
    }
    try{
      this.removeLoader();
    }catch(e){
      
    }

    //加载数据
    this.getNewsById(this.newsId);
  },
  created() {
    console.log("created()");
  },
  methods: {
    handleNavigation(){
      this.$router.push("/navigation?endLatLng="+this.news.latlng+"&lnglat="+this.LngLat)
    },   
    //-点击VR按钮
    handleVr(vrsrc){ 
      //decodeURIComponent
      this.$router.push("vr?vrsrc=" + encodeURIComponent(vrsrc))
    },
    //返回顶部
    backToTop() {
      try {
        let vm = this;
        var start = document.getElementById("articleWrap").scrollTop;

        var i = 0;
        this.interval = setInterval(() => {
          var next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
          if (next <= vm.backPosition) {
            this.scrollTo("articleWrap", 0, vm.backPosition);
            clearInterval(vm.interval);
          } else {
            this.scrollTo("articleWrap", 0, next);
          }
          i++;
        }, 16.7);
      } catch (e) {
        //alert(e)
      }
    },
    handleBacktotop() {
      this.backToTop();
    },

    //点击评论按钮
    handleComment() {
      this.$router.push(
        "comments?newsid=" +
          "&t=" +
          Math.random()
      );
    },

    //加载数据
    getNewsById(id) {
      let vm = this;
      this.conentsLoading = true;
      //Toast('正在加载...');//return;
      let data = { id: id };
      data = qs.stringify(data);
      request
        .post(this.HOST + "/Action/NewsAction.aspx?action=getNewsById", data)
        .then(function(res) {
          vm.conentsLoading = false;
          if (res.data.state == 1) {
            vm.news.id = res.data.news.ID;
            vm.news.sid = res.data.news.SID;
            vm.news.cid = res.data.news.cid;
            vm.news.title = res.data.news.LongTitle;
            vm.news.categoryName = res.data.news.categoryName;
            vm.news.address = res.data.news.address;
            vm.news.tel = res.data.news.tel;
            vm.news.star = res.data.news.star;
            vm.news.thumbnail = res.data.news.thumbnail;
            vm.news.shareimg = res.data.news.shareimg;
            vm.news.addTime = res.data.news.addTime;
            vm.news.visits = res.data.news.visits;
            vm.news.contents = res.data.news.NewsContent;
            vm.news.ad = res.data.ad;
            vm.news.copyright = res.data.copyright;
            vm.commentTotal = res.data.commentTotal;
            vm.news.latlng = res.data.news.latlng;
            vm.news.vr = res.data.news.vr;
            vm.isBack = false;
  
            if  
              
              (id == 64045 ||
                id == 64049 ||
                id == 64057 ||
                id == 64056 ||
                id == 64055 ||
                id == 64046 ||
                id == 64053)
             {
              console.log(10)
              vm.setDocumentV2(
                vm.news.title,
                '',
                vm.news.shareimg
              );
            } else {
              vm.setDocumentV2(
                vm.news.title,
                '',
                vm.news.shareimg
              );
            }
            //返回顶部
            if (document.getElementById("newsMain").scrollTo) {
              document.getElementById("newsMain").scrollTo(0, 0);
            } else {
              document.getElementById("newsMain").scrollTop = 0;
            }
          } else {
            if (vm.newsId != id) {
              return;
            }
            Toast(res.data.msg);
          }
        })
        .catch(function(response) {
          vm.loading = false;
          vm.c("", response);
        });
    },
  }
};
</script>

<style scoped>
  .main{
  }
  .server-news-title-wrap{
    padding: 0;
  }    
  .server-news-title-wrap h2{
    width: 90%;
    padding: 39% 4.67% 0 4.67%;
  }    
  .server-news-info-wrap{
    width: 90%;
    padding: 0 4.67% 4.67% 4.67%;
  }
  .list-gone{
    padding-bottom: 14%;
  }
  
.maps-loading {
    width: 100%;
    height: 100%;
    opacity: 1;
    background: transparent;
    z-index: 2;
    background-size: 4px 4px;
    position: absolute;
    left: 0;
    top: 0;
    /*background-image: url(../../static/img/map/p1-s2-bg.jpg);*/
    background-size: contain;
}
.maps-logo{
  z-index: 2;
    position: absolute;
        left: 41%;
    top: 32%;
    width: 20%;
}
.maps-conents-loading{
  width: 10.56%;
    left: 44.54%;
    top: 40.26%;
}
 .btn-navigation{
   position:relative;
   width: 100%;  
 }
 .btn-vr{
   width: 100%;
   position:relative;
 }
 
</style>

<style>
  .Icon--backToTopArrow{
    margin-bottom: 10px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/News.vue